import { useState, useEffect, useReducer } from 'react';
import Select from 'react-select';
import Swal from 'sweetalert2';

import * as helper from '../../global/helper';

import RightSideDetails from '../../global/rightSideDetails';
import BookUserTable from './bookUserTable';

import AddGuest from '../addGuest';
import AddGSTNumber from '../addGSTNumber';

import { 
    getBookingDetails, 
    postTeeTimeBook,
    getTeeSlotForBookByDateAndTeeBox,
    deleteBooking, 
} from '../../api/teeTimeAPI';

import {
    bookingDrawerReducer, 
    initiaDrawerState,
    setCompany,
    setRateDetails,
    setSubCategory,
    // setBookingUsers,
    setGreenFeeList,
    setBookingUsersAndRateDetails,
    setBookingData,
    setGuestList
} from "./reducer/drawerReducer";

import { useGreenFeeCalculator } from './hooks/useGreenFeeCalculator';

const BookingDrawer = (props) => {
    const { 
        drawer,
        masterData,
        selectedDate,
        setDrawer,
        bookSheet,      
        typeOption,
        teeTimeBookSheet,
        setBookSheet,
        isActionAllowed,
        refetchTeeSheet
        //ADD THIS PROPS    
        // bookingUserList, //replaced with bookingUsers - useReducer
        // updateBookingDetails,
    } = props;

    const [state, dispatch] = useReducer(bookingDrawerReducer, initiaDrawerState);

    const {
        guestList,
        usersList,
        companyList,
        rateDetails,
        bookingUsers,
        selectedCompany,
        // loading,
        // memberList,
        // mobileCodeList,
        // greenFeeList,
        // subCategory,
    } = state;
    
    
    //Modal States
    const [showAddGuest, setShowAddGuest] = useState(false);
    const [showCompany, setShowCompany]   = useState(false);
    
    
    const [teeSlots, setTeeSlots] = useState([]);
    const [isWeekend, setIsWeekEnd] = useState(false);
    //States Related To BookUserTable
    
    //For expanding bill details - sets when clicked on payment section for each group
    const [teeTimeGroupID, setTeeTimeGroupID] = useState(0);
 
    //Stores Booking OwnerID
    // const [guestUserID, setGuestUserID] = useState(null);

    const [selectedGuest, setSelectedGuest] = useState(null);

    //For Guest DD
    const [filteredGuestList, setFilteredGuestList] = useState([]);

    //CustomHook - useGreenFeeCalculator -->
    const { calculateGreenFee } = useGreenFeeCalculator({      
        greenFeeMasterList: masterData?.GreenFeeMaster,
        setGreenFeeList: (v) => dispatch(setGreenFeeList(v)),
        setBookingUsersAndRateDetails: (r) => dispatch(setBookingUsersAndRateDetails(r)),      
        // updateBookingDetails :(a,b,c) => updateBookingDetails(a,b,c),
    });
        
    //#region  Effects

        //Fetch Booking Details if booked --
        useEffect(() => {      
            if (drawer) {
                Config.Core.OpenDrawer();                  
                
                /**@DESC - This Takes 0 to return alldata and template id to return booking data */
                let templateId = 0;

                if(bookSheet?.ID) {
                    templateId = bookSheet.TemplateID; 
                    // if(bookSheet.OwnerID !== 0) setGuestUserID(bookSheet.OwnerID);            
                }         
                
                fetchBookingDetails(templateId, selectedDate);                              
            }else{
                // setBookSheet(bookSheet)
                // setBookingUserList([])
                // setPaymentTaggingList([])
                // setExpandedGroups({})
                // setTeeTimeGroupID(0)   //TEST AND UPDATE THIS
            }
        }, [drawer]);

        useEffect(()=>{
            //ONLY SET SLOTS WHICH ARE NOT BOOKED AND IF EDITING ADD THE CURRENT SLOT            
            const filtered = teeTimeBookSheet?.BookSheet.filter((s) => (s.Status === "Available" || bookSheet?.TemplateID == s.TemplateID));            
            setTeeSlots(filtered);
        },[teeTimeBookSheet?.BookSheet])

        useEffect(()=>{
            if(bookSheet.SubCategoryID){          
                /**@DESC - filterGuestList - IF not booked show all guest asper selected category else show Owners guest only */
                const filterAsPerCategory  = (f) => (f.SubCategoryID == bookSheet.SubCategoryID);            
                const filterForOwnersGuest = (f) => (f.RefID == bookSheet.OwnerID);                
                                
                const filtGuest = guestList.filter((g) => (!bookSheet.OwnerID)
                ? filterAsPerCategory(g) 
                : filterForOwnersGuest(g));     
                                                             
                setFilteredGuestList(filtGuest);
            } 
        },[bookSheet.SubCategoryID, bookSheet.OwnerID])  
    
        //SETS WHETHER IS WEEKEDN OR HOLIDAY
        useEffect(()=>{  
            if(!selectedDate) return;
            const day = moment(selectedDate, 'DD-MM-YYYY').day();
            setIsWeekEnd((day === 6 || day === 0));         
        }, [selectedDate]) 

    //#endregion

    //#region API calls--         

        const fetchBookingDetails = async(templateID, date) =>{
            try {                
                // dispatch({ type: 'SET_LOADING', payload: true });
                const booking = await getBookingDetails(templateID, moment(date, 'DD-MM-YYYY').format("YYYY-MM-DD"));           

                const filteredGuests = getFilteredEntities({
                    entities: booking.Guests,
                    bookingUsers: booking.BookingUsers,
                    fallbackUsers: bookingUsers,
                    type: "Guest",
                });

                const filteredUsers = getFilteredEntities({
                    entities: booking.Users,
                    bookingUsers: booking.BookingUsers,
                    fallbackUsers: bookingUsers,
                    type: "User",
                });                      

                dispatch(setBookingData( {
                    memberList: booking.Users,
                    guestList: filteredGuests,
                    usersList: filteredUsers,
                    mobileCodeList: booking.MobileCode,
                    companyList: booking.Company,    
                    // bookingUsers : booking.BookingUsers  // UNCOMMENT this once below logic is clear                
                }));
                
                /**@TODO VERIFY THIS LOGIC ----  */           
                //    if(booking.BookingUsers && bookingUsers.length == 0) dispatch(setBookingUsers(booking.BookingUsers, 'fetchBookingDetails'));        

                //Fetches OLD USERS IF ALREADY BOOKED
                // console.log("FetchBookingDetails - Existing Users => ", booking.BookingUsers);

               //For update Calculate GreenFee -           
            //    console.log('bookSheet', bookSheet);
               
                if(templateID != 0 && booking?.BookingUsers?.length !== 0){                   
                    //Calculate Green Fee For Indivial TeeTimeBooks - Store it in MAP(KEY-BookID , VALUE - Rate Object)
                    for (const individual of bookSheet?.RelatedBookings) {
                        if(individual?.ID == 0) continue;
                        const bookUsers = booking.BookingUsers.filter( bU => bU.TeeTimeBookID == individual.ID);
                                                
                        calculateGreenFee(
                            bookSheet.Hole,
                            selectedDate,
                            bookUsers,
                            //teeTimeGroupID,
                            individual?.ID,  // this is teeTimeBookID
                            teeTimeBookSheet.Holiday,
                            (individual?.Discount || 0),
                            // (individual.UserType != 'User' ? (individual?.Discount || 0) : 0),
                            booking?.BookingUsers,
                            'updateBook',
                            bookSheet.TemplateID,
                        );                                                
                    }                    
                }
                               
            } catch (error) {
                Swal.fire({ icon: 'error', titleText : error.message});
            }finally{
                // dispatch({ type: 'SET_LOADING', payload: false });
            }
        } 

        const fetchTeeSlots=async(teebox)=>{
            try {
                Swal.fire({
                    titleText: 'Loading',
                    text: 'Please Wait...',
                    showConfirmButton: false,
                    onOpen: () => Swal.showLoading()                
                });
             
                // FETCH NEW TEE SLOTS AS PER DATE AND SELECTED TEEBOX
                const response = await getTeeSlotForBookByDateAndTeeBox(moment(selectedDate, "DD-MM-YYYY").format('YYYY-MM-DD'), teebox);
                // //FILTER & Show Available             
                const filtered = response.filter((s) => (!s.Status || bookSheet?.ID == s.ID));    
                setTeeSlots(filtered || [])
                if(!!filtered && filtered.length > 0){                   
                    const cTemplate = filtered?.find((t,i)=> t.ID == (!!bookSheet?.ID ? bookSheet?.ID :0));                                                        
                    updateBookingDetails('TemplateID', cTemplate?.TemplateID || filtered[0]?.TemplateID); //Set Current or first Slot
                }                
            } catch (err) {                  
                Swal.fire({ icon: 'error', titleText : err.message});
            }finally{                    
                Swal.close();
            }
        }
        
        const addBookingHandler = async() => {
            const btn = $('#btnSave');
            helper.StartProcessing(btn);

            const rate = rateDetails.get(Number(0))|| 0;

            if (!!rate && rate?.DiscountPercent != 0) { 
                bookSheet.RelatedBookings = bookSheet?.RelatedBookings.map(rb => { 
                    if (rb.ID == 0) rb.Discount = rate?.DiscountPercent;                    
                    return rb
                });
            }
        
            try { 
                const bookSheetDetails = {
                    ID:                 bookSheet.ID || 0,
                    TemplateID:         bookSheet.TemplateID,
                    CompanyID:          selectedCompany?.ID || 0,
                    Hole:               bookSheet.Hole || 18,
                    BookDate:           moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD'),
                    Comment:            bookSheet.Comment,
                    RelatedBookings:    bookSheet.RelatedBookings,
                }

                let bUsers = [];              

                bookingUsers.forEach(function (e, i) {
                    bUsers.push({
                        ID:                 0, 
                        TeeTimeBookID:      e.TeeTimeBookID,                      
                        UserID:             e.UserID,  
                        UserType:           e.UserType,
                        IsCartRequired:     e.IsCartRequired,
                        IsCaddyRequired:    e.IsCaddyRequired,
                    });
                });             

                // console.log('bookSheetDetails', bookSheetDetails);
                // console.log('bookingUsers', bookingUsers);
                // console.log('bUsers', bUsers);

                // return;

                await postTeeTimeBook(bookSheetDetails, bUsers);   
                refetchTeeSheet();       

                /**@FIND - WHY ITS BEING DONE */
                // setTimeout(() => {
                //     if(!!bookSheet?.TeeBox){
                //         updateTypeDetails('TeeBox', bookSheet?.TeeBox)
                //         // fetchTeeTimeBookSheetData(moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD'), bookSheet?.TeeBox) // @REWORK - commenting this as the above function will call this as state changes
                //     }else{
                //         updateTypeDetails('TeeBox', type.TeeBox)
                //         // fetchTeeTimeBookSheetData(moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD'), type.TeeBox)  // @REWORK - commenting this as the above function will call this as state changes
                //     }
                // }, 500);

                closeDrawer();
                if (bookSheetDetails.ID) {
                    Swal.fire({
                        toast: true,
                        icon: 'success',
                        titleText: 'Booking updated successfully!',
                        position: 'bottom-end',
                        showConfirmButton: false,
                        timer: 1500,
                        animation: false,
                        customClass: { popup: 'margin-20'},
                    });
                }else{
                    Swal.fire({
                        icon: 'success',
                        titleText: 'Booking added successfully!',
                        showConfirmButton: false,
                        timer: 1500,
                    });
                }
            } catch (err) {      
                // console.log(err.response.data.logMessage);        
                // let icon = err.logMessage == 'Invalid Player Count' ? 'warning' : 'error';
                Swal.fire({
                    icon                  : 'error',
                    titleText             : err.logMessage || 'Error!',
                    text                  : err.message,
                    buttonsStyling        : false,
                    confirmButtonClass    : 'btn btn-brand',
                });
                return;
            }finally{
                helper.StopProcessing(btn);
            }
        } 
        
        const cancelBookingHandler = async(bookId) => {
            const btn = $('#btnCancel');
            helper.StartProcessing(btn);          
            
            try {
                const isEmptyOrSpaces = bookSheet.Comment == null || bookSheet.Comment.match(/^ *$/) !== null || /\s/.test(bookSheet.Comment);
                const swalResult = await Swal.fire({
                    title               : 'Are you sure?',
                    text                : "You won't be able to revert this!",
                    icon                : 'warning',
                    showCancelButton    : true,
                    buttonsStyling      : false,
                    reverseButtons      : true,
                    showLoaderOnConfirm : true,
                    confirmButtonClass  : 'btn btn-brand',
                    cancelButtonClass   : 'btn btn-secondary',
                    confirmButtonText   : 'Delete',
                    preConfirm: async () => {
                        try {
                            await deleteBooking(bookId, bookSheet.TeeBox, isEmptyOrSpaces ? null : bookSheet.Comment)
                        } catch (err) {
                            helper.StopProcessing(btn);
                            Swal.fire({
                                icon                : 'error',
                                titleText           : 'Error!',
                                text                : err.message,
                                buttonsStyling      : false,
                                confirmButtonClass  : 'btn btn-brand',
                            });
                            return;
                        }
                    },
                });              
                if (!swalResult.value) return;

                refetchTeeSheet(); 
                closeDrawer();
                Swal.fire({
                    icon: 'success',
                    titleText: 'Booking deleted successfully!',
                    showConfirmButton: false,
                    timer: 1500,
                });
            } catch (err) {
              
                Swal.fire({
                    icon                  : 'error',
                    titleText             : 'Error!',
                    text                  : err.message,
                    buttonsStyling        : false,
                    confirmButtonClass    : 'btn btn-brand',
                });
                return;
            }finally{
                helper.StopProcessing(btn);
            }
        }
    //#endregion

    //#region Handler  


        const updateBookingDetails = (field, value, teeTimeBookID) => {
            // console.log('updateBookingDetails', field, value ,teeTimeBookID);

            // Update bookSheet
            setBookSheet(prevState => {
                // If this is for a specific templateId
                if (teeTimeBookID >= 0) {
                    // Find related bookings with this templateId
                    const updatedRelatedBookings = prevState.RelatedBookings.length > 0
                        && prevState.RelatedBookings.map(booking => { 
                            if (booking.ID == parseInt(teeTimeBookID)) {
                                // Update only this specific related booking
                                return { ...booking, [field]: value };
                            }
                            return booking
                        })
                    if (field === 'Discount') {
                        const filteredUser = bookingUsers.filter(f => f.TeeTimeBookID == teeTimeBookID);

                        calculateGreenFee(
                            bookSheet.Hole,
                            selectedDate,
                            filteredUser,
                            teeTimeBookID,
                            teeTimeBookSheet.Holiday,
                            value,
                            bookingUsers,
                            field,
                            bookSheet.TemplateID,
                        );
                    }    

                    return { 
                        ...prevState, 
                        RelatedBookings: updatedRelatedBookings 
                    };
                } else {
                        // If Hole is updated, it applies to the whole slot, so every related
                        // booking needs its own recalculation with its own Discount -- a single
                        // combined call (passing every user across every booking at once) only
                        // ever updates one rateDetails entry (whichever booking happens to be
                        // first in bookingUsers), using just one booking's discount, and leaves
                        // every other booking's total stale. Loop per booking instead, same
                        // pattern as fetchBookingDetails (lines 190-210).
                        if (field === 'Hole') {
                            setTimeout(() => {
                                (bookSheet?.RelatedBookings || []).forEach(individual => {
                                    const groupUsers = bookingUsers.filter(f => f.TeeTimeBookID == individual.ID);
                                    if (groupUsers.length === 0) return;

                                    calculateGreenFee(
                                        value,
                                        selectedDate,
                                        groupUsers,
                                        individual.ID,
                                        teeTimeBookSheet.Holiday,
                                        individual.Discount || 0,
                                        bookingUsers,
                                        field,
                                        bookSheet.TemplateID,
                                    );
                                });
                            }, 100);
                        }
                        
                        let newBookSheet = { ...prevState, [field]: value };

                        
                        if(field === "Type") {
                            newBookSheet.UserID = '';                                                                                   
                            delete newBookSheet.OwnerID;                                                                          
                            if(field != "SubCategoryID") newBookSheet.SubCategoryID = '';  // This doesnt make sense                                              
                        }
                        
                    return newBookSheet;
                }
            });
        };

        const addBookingUserHandler = () => {            
            // if(!!bookSheet?.ID) return;   //If Already Booked
            
            if (bookSheet?.UserID > 0) {                      
                //Retaining OLD LOGIC --          
                let newUser   = usersList.find((f) => f.ID == bookSheet.UserID);                          

                //check if User Exist 
                const ifExist = bookingUsers.find(f => f.UserID == bookSheet.UserID & f.UserType == "User");
                if(ifExist) {
                   return Swal.fire({
                        icon: 'warning',
                        titleText: 'Member Already Added',                       
                        showConfirmButton: false,
                        timer: 1500,                        
                    });
                }

                // Determine if the user should have cart/caddy required
                const isGuest       = newUser.SubCategoryID == 3 || newUser.SubCategoryID == 5;
                const isValidMember = newUser.IsValidMember === "Y";

                // Add the new user to the list
                newUser = { 
                    ...newUser, 
                    UserID: newUser.ID, 
                    UserType: "User", 
                    IsCaddyRequired: "N", 
                    IsCartRequired: "N",
                    IsCartUpdated: false, // Allow the calculateGreenFee logic to determine cart/caddy requirements
                    isToggleDisabled: isGuest || !isValidMember, // Disable toggle for guests and invalid members
                    TeeTimeBookID: 0 
                };     
                
                const currentUserGroup = bookingUsers.filter(f => f.TeeTimeBookID == 0);

                /**@todo - Check if the setTimeout Is Required */
                // Trigger Calculation after state update           
                setTimeout(() => {
                    calculateGreenFee(
                        bookSheet.Hole,
                        selectedDate,
                        [...currentUserGroup, newUser],
                        teeTimeGroupID,
                        teeTimeBookSheet.Holiday,
                        (bookSheet?.RelatedBookings?.find(f => f?.ID == teeTimeGroupID)?.Discount || 0),
                        bookingUsers,
                        'addUser',
                        bookSheet.TemplateID,
                    );
                }, 100);
                
                // calculateGreenFee already does this  but doesnot work as intended 
                // - try passing bookingUsers as a prop to calculateGreenFee-->
                // newList.push(newUser);
                // dispatch(setBookingUsers(newList));
                          
                setBookSheet((prev) => ({ ...prev, UserID: '' }));
                setFilteredGuestList([]);
            }
        };
        
        const addBookingGuestHandler = (type) => {
            
            //GuestID is for MembersGuest - UsersGuest ~ Current Only Guest
            // if (bookSheet.GuestID || bookSheet.UserID) {
            if ((!!bookSheet.GuestID || (!!bookSheet.UserID &&  bookSheet.Type != 'Member')) ) {
                //Check IF Exist -> 
                const IfExists = bookingUsers.some(user => user.UserID == (bookSheet.GuestID || bookSheet.UserID) && (type == "user" ? user.UserType == "UsersGuest" : user.UserType == "Guest"));             
                if(IfExists) return;
                
                let newGuest = guestList.find(f => f.ID == (bookSheet.GuestID || bookSheet.UserID));                
                if (!newGuest) return;

                newGuest =  { 
                    ...newGuest, 
                    UserID: newGuest.ID, 
                    IsCaddyRequired: "Y", 
                    IsCartRequired: "Y", 
                    IsValidMember: "N", 
                    TeeTimeBookID: 0, 
                    isCartUpdated: true, 
                    UserType: type == "user" ? "UsersGuest" : "Guest"
                };

                const currentUserGroup = bookingUsers.filter(f => f.TeeTimeBookID == 0);
                setTimeout(() => {
                    calculateGreenFee(
                        bookSheet.Hole,
                        selectedDate,
                        [...currentUserGroup, newGuest],
                        teeTimeGroupID,
                        teeTimeBookSheet.Holiday,
                        (bookSheet?.RelatedBookings?.find(f => f?.ID == teeTimeGroupID)?.Discount || 0),
                        bookingUsers,
                        'addGuest',
                        bookSheet.TemplateID,
                    );
                }, 100);

                //DONT CLEAR USERID If UserGuest is Added
                let dataToClear = { GuestID : null}
                if(type != "user") dataToClear.UserID = null;

                setBookSheet(prev => ({ ...prev, ...dataToClear }));
                setSelectedGuest(null);
            }
        };

        const addNewGuestToBooking = (type,newGuest) =>{               
            //Should be in the guestList & setFilteredGuest 
            dispatch(setGuestList([...guestList, newGuest]));
            setFilteredGuestList( p => ([...p, newGuest]));
            
            newGuest.UserID          = newGuest.ID;
            newGuest.UserType        = (type == "user") ? "UsersGuest" : "Guest";
            // newGuest.IsCaddyRequired = "Y"; 
            // newGuest.IsCartRequired  = "Y"; 
            // newGuest.IsValidMember   = "N"; 
            // newGuest.TeeTimeBookID   = 0; 
            // newGuest.isCartUpdated   = true; 
            const currentUserGroup = bookingUsers.filter(f => f.TeeTimeBookID == 0);

            calculateGreenFee(
                bookSheet.Hole,
                selectedDate,
                [...currentUserGroup, newGuest],
                teeTimeGroupID,
                teeTimeBookSheet.Holiday,
                (bookSheet?.RelatedBookings?.find(f => f?.ID == teeTimeGroupID)?.Discount || 0),
                bookingUsers,
                'addGuest',
                bookSheet.TemplateID,
            );
        }

        const onTypeChangeHandler =({target})=>{
            updateBookingDetails('Type', target.value);
                    
            //clearRates();
            setFilteredGuestList([]);
            dispatch(setSubCategory(null))           

            // dispatch(setRateDetails({})); //Resets to Initial State;                
            // dispatch(setRateDetails({Bucket: 0, Club: 0, Discount: 0, Cgst : 0, Sgst : 0, Total : 0}));                
            
            //Handled in updateBookingDetails -
            // updateBookingDetails('UserID', ''),        
            // updateBookingDetails('SubCategoryID', '')}
        }

        const memberDDHandler =(event) => { 
            updateBookingDetails('UserID', event.value);
            updateBookingDetails('SubCategoryID', 5); // To Filter & Fill MembersGuest
            updateBookingDetails('OwnerID', event.value); // To Filter & Fill MembersGuest           
        }
    
        const SubCategoryDDHandler =(event) => { 
            updateBookingDetails('SubCategoryID', event.value)        
            // setGuestUserID(null)
            resetGuest();
        }
    
        const onTeeBoxChange=(teebox)=>{
            updateBookingDetails('TeeBox', teebox);
            fetchTeeSlots(teebox);
        }
    //#endregion
    
    //#region UTILS    
        const openGuestModal =()=>{
            // validate Subcategory
            if(!bookSheet?.SubCategoryID){
                return Swal.fire({
                    icon : 'warning',
                    title : 'Please Select Guest Category',
                    timer: 1500,
                    showConfirmButton:false,
                });
            }
            setShowAddGuest(true);
            
        }
        
        const getUserList =()=>{
            //Returns FilteredUserList without added User --
            let ids = new Set(bookingUsers.filter(u => u.UserType === 'User').map(({ UserID }) => UserID));
            
            // return (usersList.filter(({ ID }) => !ids.has(ID)).map(c => ({
            //     label: `${c.Name} (${c.MembershipNo})`,
            //     value: c.ID,
            //     subCatID: c.SubCategoryID,
            //     SubscriptionExpiresOn: c.SubscriptionExpiresOn,
            //     MembershipExpiresOn: c.MembershipExpiresOn,
            // })));
            return (usersList.map(c => ({
                label: `${c.Name} (${c.MembershipNo})`,
                value: c.ID,
                subCatID: c.SubCategoryID,
                SubscriptionExpiresOn: c.SubscriptionExpiresOn,
                MembershipExpiresOn: c.MembershipExpiresOn,
            })));
        }
    
        const getGuestList =()=>{          
            //Returns FilteredUserList without added User --
            let idsGuest = new Set(bookingUsers.filter(u => u.UserType === 'Guest' || u.UserType == "UsersGuest").map(({ ID }) => ID));
            return (filteredGuestList.filter(({ ID }) => !idsGuest.has(ID)).map(c => ({
                label: `${c.Name} (${c.Mobile})`,
                value: c.ID,
                subCatID: c.SubCategoryID
            })));
        }

        function getFilteredEntities({ entities, bookingUsers, fallbackUsers, type }) {
            return bookingUsers
            ? entities.filter(entity => 
                !bookingUsers.some(bu => bu.UserID === entity.ID)
            )
            : entities.filter(entity => 
                !fallbackUsers.some(bu => bu.UserType === type && bu.UserID === entity.ID)
            );
        }

        const resetUser  =(userType)=>{ 
            updateBookingDetails(userType, null)
            if(userType == "UserID"){
                updateBookingDetails('SubCategoryID', null);
                updateBookingDetails('OwnerID', null)
            }
        };  

        const resetGuest  =()=>{
            updateBookingDetails('UserID', null);
            setSelectedGuest(null);
        }

        const closeDrawer = () =>{    
            Config.Core.CloseDrawer();
            setTimeout(() => {
                setDrawer(false);                   
                // updateTypeDetails('TeeBox', type.TeeBox)     
            }, 500);

            // setBookSheet({Hole:'18'}); //REWORK - Change this to reset bookSheet State     
        }

    //#endregion

    /**@todo - Implement Loader the setter done, work on using the loading state and loader component */

    return (<>
        <RightSideDetails title="Book Tee Time" onCloseDrawer={closeDrawer}>
            <div className="kt-portlet">
                <div className="kt-portlet__body padding-t30 padding-b0">
                    <form id="ModalHolder" className="kt-form kt-form--label-right padding-10" role="form">
                        <div className="form-group row">
                            <label className="col-form-label col-lg-3">Date</label>
                            <div className="col-xl-6 col-lg-8">
                                <input 
                                    id="lblDate" 
                                    name="lblDate" 
                                    disabled="disabled" 
                                    type="text" 
                                    className="form-control w-50" 
                                    value={moment(selectedDate, 'DD-MM-YYYY').format('DD-MM-YYYY')} 
                                />
                            </div>
                        </div>

                        {/* SHOW ONLY WHEN A SLOT IS ALREADY BOOKED */}
                        {bookSheet?.RelatedBookings[0]?.ID != 0 && (
                            <div id="pnlTeeBox" className="form-group row">
                                <label className="col-form-label col-lg-3"> Tee Box <span className="red">*</span></label>
                                <div className="col-xl-6 col-lg-8">                                
                                    <select 
                                        id="ddlTeeBox"  name="ddlTeeBox" className="form-control w-50"
                                        value={(bookSheet?.TeeBox)}                                           
                                        onChange={({target}) => onTeeBoxChange(target.value)}                                            
                                    >
                                        <option value={1}> 1 </option>
                                        <option value={10}> 10 </option>
                                    </select>
                                    
                                </div>
                            </div> 
                        )}

                         {/* DISABLE WHEN A SLOT IS NOT BOOKED */}
                        <div id="pnlSlot" className="form-group row">
                            <label className="col-form-label col-lg-3">Slot <span className="red">*</span></label>
                            <div className="col-xl-6 col-lg-8">                             
                                <Select 
                                    id="ddlSlot" 
                                    name="ddlSlot"
                                    className="multi-custom w-50"
                                    isDisabled={bookSheet?.RelatedBookings[0]?.ID != 0 ? "" : 'disabled'}
                                    value={(teeSlots && teeSlots.length > 0 && bookSheet?.TemplateID) && {label: teeSlots.find(c => c.TemplateID == bookSheet.TemplateID)?.Slot, value: bookSheet?.TemplateID}}
                                    onChange={(event) => updateBookingDetails('TemplateID', event.value)}
                                    options={teeSlots.map(a => ({
                                        label: a.Slot,
                                        value: a.TemplateID,
                                    }))}
                                />                               
                            </div>
                        </div> 
                        <div className="form-group row">
                            <label className="col-form-label col-lg-3"></label>
                            <div className="kt-radio-inline col-xl-6 col-lg-8 margin-l10">
                                <label id="pnlRedio18" htmlFor='redio18' className="kt-radio kt-radio--brand">
                                    {/**@TODO - remove TeeTimeGroupID if not required use to set in tooglGroupExpansion */}
                                    <input 
                                        name="hole"  id="redio18"  type="radio" 
                                        value={'18'} defaultChecked={bookSheet.Hole == '18'} 
                                        disabled={(teeTimeGroupID != 0 || bookSheet?.ID > 0 ||bookingUsers.length == 4) ? "disabled" : ''}
                                        onChange={({ target }) => updateBookingDetails('Hole', target.value)}
                                    />
                                        18 Holes
                                    <span></span>
                                </label>

                                {(!teeTimeBookSheet?.Holiday && !isWeekend) && (
                                    <label className="kt-radio kt-radio--brand"  htmlFor='redio9'>
                                        {/**@TODO - remove TeeTimeGroupID if not required use to set in tooglGroupExpansion */}
                                        <input 
                                            name="hole" id="redio9" type="radio" 
                                            value={"9"} defaultChecked={bookSheet.Hole == '9'}                                     
                                            disabled={(teeTimeGroupID != 0 || bookSheet?.ID > 0 || bookingUsers.length == 4) ? "disabled" : ''}
                                            onChange={({ target }) => updateBookingDetails('Hole',target.value)}
                                            />
                                            9 Holes
                                        <span></span>
                                    </label>
                                )}
                            </div>
                        </div>

                        <div id="pnlType" className="form-group row">
                            <label className="col-form-label col-lg-3"> Category <span className="red"></span></label>
                            <div className="col-xl-6 col-lg-8">
                                <div>
                                    <select 
                                        id="ddlType" name="ddlType" placeholder="Select Category"
                                        className="form-control w-50"                                
                                        defaultValue={typeOption[0]}
                                        /**@TODO - disable for single category Users either (guest) OR (members & members guest) */                                     
                                        disabled={(teeTimeGroupID != 0 || bookingUsers.length == 4) ? "disabled" : ''}
                                        onChange={onTypeChangeHandler}
                                    >
                                        {typeOption.map((t,i)=>( <option key={`type_${i}`} value={t}> {t} </option> ))}
                                    </select>
                                </div>
                            </div>
                        </div>

                        {bookSheet.Type == "Member" ? (<>
                            <div id="UserHolder">
                                <div className="form-group row">
                                    <label className="col-form-label col-lg-3">Member</label>
                                    <div className="col-xl-6 col-lg-8">
                                        <div className="input-group" >
                                            <div style={{width: "60%"}}  >
                                                <Select
                                                    id="ddlUser" name="ddlUser" className="ddlUser" placeholder="Select User"
                                                    // isDisabled={(teeTimeGroupID != 0 || bookSheet?.ID > 0 || bookingUsers.length == 4) ? "disabled" : ''}
                                                    isDisabled={(teeTimeGroupID != 0 || bookingUsers.length == 4) ? "disabled" : ''}
                                                    value={(usersList && usersList.length > 0 && bookSheet.UserID) && {label: `${usersList.find(m => m.ID == bookSheet.UserID).Name} (${usersList.find(m => m.ID == bookSheet.UserID).Mobile})`, value: bookSheet.UserID} || ''}
                                                    onChange={memberDDHandler}
                                                    options={getUserList()}
                                                />
                                            </div>
                                            <div className="input-group-append" style={{zIndex: 0}}>
                                                <button className="btn btn-secondary kt-select-reset" type="button" 
                                                    disabled={teeTimeGroupID != 0 ? "disabled" : ""}
                                                onClick={()=> resetUser('UserID')} ><i className="flaticon2-delete kt-icon-sm padding-0"></i></button>
                                            </div>
                                            <button id="btnAddUser" className="btn btn-label-brand margin-l10 margin-r0" type="button" onClick={() => addBookingUserHandler()}>Add</button>                                                
                                        </div>
                                    </div>
                                </div>
                            </div>       
                                
                            {/* Members Guest / UsersGuest */}
                                {!!bookSheet.UserID && (<>
                                    <div id="UserGuestHolder" >
                                        <div className="form-group row">
                                            <label className="col-form-label col-lg-3"> Members Guest</label>
                                            <div className="col-xl-6 col-lg-8">
                                                <div className="input-group">
                                                    <div style={{width: "60%"}}  >
                                                        <Select 
                                                            value={(guestList && guestList.length > 0 && bookSheet.GuestID) && {label: `${guestList.find(m => m.ID == bookSheet.GuestID)?.Name} (${guestList.find(m => m.ID == bookSheet?.GuestID)?.Mobile})`, value: bookSheet?.GuestID} || ''}
                                                            onChange={(event) => {
                                                                updateBookingDetails('GuestID', event.value);
                                                            }}
                                                            name="ddlUserGuest"
                                                            placeholder="Select Member Guest"
                                                            isDisabled={(teeTimeGroupID != 0 || bookingUsers.length == 4) ? "disabled" : ''}
                                                            id="ddlUserGuest"
                                                            data-live-search="true"
                                                            className="ddlUserGuest"
                                                            options={getGuestList()}
                                                        />
                                                    </div>
                                                    <div className="input-group-append"  style={{zIndex: 0}}>
                                                        <button className="btn btn-secondary kt-select-reset" type="button" onClick={()=> resetUser('GuestID')}><i className="flaticon2-delete kt-icon-sm padding-0"></i></button>
                                                    </div>
                                                    <button id="btnUserAddGuest" className="btn btn-label-brand margin-l10 margin-r0" type="button" onClick={() => addBookingGuestHandler("user")}>Add</button>
                                                    <button id="btnNewUserGuest" className="btn btn-label-brand margin-l10" type="button" data-toggle="modal" data-target="#modalGuest"  onClick={openGuestModal} >New</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>)}
                            </>
                        ) : (
                            <>
                                <div className="form-group row">
                                    <label className="col-form-label col-lg-3">SubCategory <span className="red">*</span></label>
                                    <div className="col-xl-6 col-lg-8">
                                        <Select 
                                            id="ddlSubCategoryID" 
                                            name="ddlSubCategoryID"
                                            className="multi-custom"
                                            placeholder="Select Category"
                                            isDisabled={(teeTimeGroupID != 0 || bookingUsers.length == 4) ? "disabled" : ''}
                                            value={bookSheet?.SubCategoryID && masterData?.GuestCategoryMaster.length > 0 && {label: masterData?.GuestCategoryMaster.find((m) => m.ID == bookSheet.SubCategoryID)?.Name, value: bookSheet.SubCategoryID}  || ''}
                                            onChange={SubCategoryDDHandler}
                                            options={ masterData?.GuestCategoryMaster.map(a => ({
                                                label: a.Name,
                                                value: a.ID,
                                            }))}
                                        /> 
                                    </div>
                                </div>
                                <div id="GuestHolder" >
                                    <div className="form-group row">
                                        <label className="col-form-label col-lg-3">Guest</label>
                                        <div className="col-xl-6 col-lg-8">
                                            <div className="input-group">
                                                <div style={{width: "60%"}}  >
                                                    <Select
                                                        id="ddlGuest"
                                                        name="ddlGuest"
                                                        placeholder="Select Guest"
                                                        data-live-search="true"
                                                        className="ddlGuest"
                                                        isDisabled={(teeTimeGroupID != 0 || bookingUsers.length == 4) ? "disabled" : ''}                                                                                                              
                                                        value={selectedGuest || ''}
                                                        onChange={(g) => {                                                           
                                                            updateBookingDetails('UserID', g.value);
                                                            setSelectedGuest(g);
                                                            // setSubCatID(event.subCatID); ~NO NEED TO UPDATE THIS
                                                        }}
                                                        options={getGuestList()}
                                                    />
                                                </div>
                                                <div className="input-group-append"  style={{zIndex: 0}}>
                                                    <button className="btn btn-secondary kt-select-reset" type="button" onClick={()=> resetGuest('GuestID')}><i className="flaticon2-delete kt-icon-sm padding-0"></i></button>
                                                </div>
                                                <button id="btnAddGuest" className="btn btn-label-brand margin-l10 margin-r0" type="button" onClick={() => addBookingGuestHandler("guest")}>Add</button>
                                                <button id="btnNewGuest" className="btn btn-label-brand margin-l10" type="button" data-toggle="modal" data-target="#modalGuest"  onClick={openGuestModal} >New</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )} 
                    </form> 
                    <div className="row margin-b5" style={{ display: "flex", justifyContent: "flex-end" }}>
                        <div className="col-xs-12 text-right padding-r20">
                            <strong>
                                Available Carts: <span id="lblAvailableCart">{masterData?.CartStatus?.Available}</span>
                            </strong>
                        </div>
                    </div>
                    <div>
                        <BookUserTable 
                            settlementList    = {masterData.SettleMaster}
                            isHoliday         = {teeTimeBookSheet?.Holiday}
                            bookSheet         = {bookSheet}
                            rateDetails       = {rateDetails}
                            selectedDate      = {selectedDate}
                            bookingUsers      = {bookingUsers}
                            teeTimeGroupID    = {teeTimeGroupID}
                            setTeeTimeGroupID = {setTeeTimeGroupID}
                            selectedCompany   = {selectedCompany}
                            calculateGreenFee = {calculateGreenFee}
                            companyList        = {companyList}
                            setSelectedCompany = {(v)=> dispatch(setCompany(v))}
                            setShowCompany      = {setShowCompany}
                            updateBookingDetails = {updateBookingDetails}
                            cancelBookingHandler = {cancelBookingHandler}
                            isActionAllowed     = {isActionAllowed}
                        />
                    </div>
                </div>
                <div className="kt-portlet__foot">
                    <div className="kt-form__actions">
                        <div className="row">
                            <div className="col-lg-12 text-right">
                                {isActionAllowed && (
                                    <button id="btnSave" type="button" className="btn btn-brand d-inline-block" onClick={() => addBookingHandler()}>{bookSheet?.RelatedBookings[0]?.ID != 0 ? 'Update Booking' : 'Save Booking' }</button>
                                )}
                                <button id="btnCloseDrawer" type="button" className="btn btn-secondary margin-l10" onClick={closeDrawer}>Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

           
        </RightSideDetails>    

        {/* MODALS */}

        {showAddGuest && (
            <AddGuest
                show={showAddGuest}
                onDismissModal  = {setShowAddGuest} 
                UserReferenceID = {bookSheet?.OwnerID || 0}
                SubCategoryID   = {bookSheet?.SubCategoryID}
                // setShowAddPayment={setShowAddPayment} 
                // mobileCodeList={mobileCodeList}
                // fetchBookingDetails={() => fetchBookingDetails(bookSheet.ID ? bookSheet.TemplateID : 0, moment(selectedDate, 'DD-MM-YYYY').format('YYYY-MM-DD'))} 
                addGuestToBooking={addNewGuestToBooking} 
                bookingUserList={bookingUsers}
            />
        )}

        {showCompany && (
            <AddGSTNumber
                show           = {showCompany}
                onDismissModal = {()=> setShowCompany(false)} 
                refID          = {showCompany}
                selectCompany = {selectedCompany}
                setSelectCompany = {(v)=> dispatch(setCompany(v))}                
            />
        )}

    </>);
}

export default BookingDrawer;














